<template>
  <div class="ele-wrap">
    <resize-container :tabShow="tabShow">
      <div class="tree-content box" v-show="tabShow" slot="left">
        <tab-tree
          :data="viewTreeData"
          :measureId="queryMeasureId"
          @tabTreeDefault="tabTreeDefault"
          @tabTreeClick="tabTreeClick"
        ></tab-tree>
      </div>
      <div class="content">
        <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
        <div class="search-box box">
          <time-search
            ref="timeSearch"
            :control="{ data: timeData }"
            @timeControlChange="timeControlChange"
            @timeControlClick="TimeControlClick"
          >
            <div class="time-search-slot">
              <el-select
                style="width: 120px; margin-left: 10px"
                v-show="showSearchType"
                v-model="searchType"
              >
                <el-option label="按小时间隔" value="hour"></el-option>
                <el-option label="按采集间隔" value="measuring"></el-option>
              </el-select>
            </div>
          </time-search>
        </div>
        <div class="grid-content item-box">
          <div class="details-content">
            <div class="item-box box">
              <measure-info
                :measureId="analysisChartObj.measureId"
              ></measure-info>
            </div>
            <div class="item-box tab-box box">
              <el-radio-group size="small" v-model="selectedTab">
                <el-radio-button
                  v-for="(item, index) in tabData"
                  :key="index"
                  :label="item.value"
                  >{{ item.label }}</el-radio-button
                >
              </el-radio-group>
            </div>
            <template v-if="selectedDate.dateType !== 'timeInterval'">
              <div
                class="item-box homocycle-ratio-box box"
                v-if="selectedTab === 'ele'"
              >
                <homocycle-ratio ref="homocycleRatio"></homocycle-ratio>
              </div>
              <div
                class="item-box homocycle-ratio-box box"
                v-if="selectedTab === 'water'"
              >
                <water-ratio
                  ref="homocycleRatio"
                  :unit="'m³'"
                  :type="'water'"
                ></water-ratio>
              </div>
              <!-- <div class="item-box homocycle-ratio-box box" v-if="selectedTab === 'forwardFlow'">
                <water-ratio ref="homocycleRatio" :unit="forwardFlowUnit" :type="'gasp'"></water-ratio>
              </div> -->
              <div
                class="item-box homocycle-ratio-box box"
                v-if="selectedTab === 'reverseFlow'"
              >
                <water-ratio
                  ref="homocycleRatio"
                  :unit="forwardFlowUnit"
                  :type="'gasr'"
                ></water-ratio>
              </div>
            </template>
            <div class="item-box chart-box box">
              <div class="btn-circular" @click="bindPrev">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div class="btn-circular btn-circular-right" @click="bindNext">
                <i class="el-icon-arrow-right"></i>
              </div>
              <analysis-chart
                ref="analysisChart"
                :forwardFlowUnit="forwardFlowUnit"
                v-if="showAnalysisChart"
              ></analysis-chart>
            </div>
          </div>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import TabTree from "@/components/common/TabTree.vue";
import BtnShow from "@/components/common/BtnShow.vue";
import MeasureInfo from "@/components/page/ele/MeasureInfo.vue";
import AnalysisChart from "@/components/page/ele/AnalysisChart.vue";
import TimeSearch from "@/components/common/TimeSearch.vue";
import HomocycleRatio from "@/components/page/ele/HomocycleRatio.vue";
import WaterRatio from "@/components/page/ele/WaterRatio.vue";
import ResizeContainer from "@/components/common/resizeContainer.vue";
import api from "@common/api/index.js";
import { findDataByParam } from "@/utils/index.js";
import handleData from "@/utils/handleData.js";
import dayjs from "dayjs";
import Cookie from "@/utils/cookie";
let allTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "week",
    label: "周",
  },
  {
    type: "month",
    label: "月",
  },
  // {
  //   type: "year",
  //   label: "年",
  // },
  {
    type: "timeInterval",
    label: "时段",
  },
];
let eleTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  },
  {
    type: "timeInterval",
    label: "时段",
  },
];
export default {
  name: "ele",
  // 引用组件
  components: {
    TabTree,
    BtnShow,
    // EleDetail,
    // EleInfo,
    // EleState,
    // EleDataChart,
    MeasureInfo,
    AnalysisChart,
    TimeSearch,
    HomocycleRatio,
    WaterRatio,
    ResizeContainer,
  },
  data() {
    return {
      timeData: allTimeData,
      tabData: [],
      searchType: "hour",
      tabShow: true,
      viewTreeData: [],
      selectedTab: "",
      selectedMeasure: {
        measureId: "",
        measureName: "",
      },
      selectedDate: {
        startTime: "",
        endTime: "",
      },
      showSearchType: false,
      analysisChartObj: {
        measureId: "",
        measureName: "",
        startTime: "",
        tabType: "",
        endTime: "",
        searchType: "",
      },
      showHomocycleRatio: false,
      //运行状态
      runningState: null,
      showAnalysisChart: true,
      queryMeasureId: "",
      forwardFlowUnit: "",

      isStart: true,
    };
  },
  // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  beforeCreate() {},
  // 实例已经创建完成之后被调用。
  created() {},
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted() {
    const companyId = Cookie.getCookie("companyId");
    this.init(companyId);
  },
  // keep-alive组件激活时调用
  activated() {
    let vm = this;
    //vm.$route.query
    let query = vm.$route.query;
    if (query.measureId) {
      vm.queryMeasureId = query.measureId;
    }
    if (query.code) {
      const item = window.baseConfig.collectData.find(
        (c) => c.code == query.code
      );
      if (item) {
        vm.selectedTab = item.tabName;
      }
    }

    this.$refs.analysisChart.setChartResize();
  },
  // 数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子
  updated() {},
  //当前路由改变
  beforeRouteUpdate() {},
  // Vue 实例销毁后调用
  destroyed() {},
  // 计算属性
  computed: {},
  // 数据监听
  watch: {
    selectedTab(val, oldVal) {
      this.updateData(val, oldVal);
    },
  },
  // 方法定义
  methods: {
    init(companyId) {
      let vm = this;
      api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(companyId, "/analysis/ele6", null)
        .then((res) => {
          const viewTreeData = findDataByParam("viewTree", true, res.data);
          const forwardFlowUnit = findDataByParam(
            "forwardFlowUnit",
            false,
            res.data
          );
          vm.viewTreeData = viewTreeData;
          vm.forwardFlowUnit = forwardFlowUnit;
        });
    },
    updateData(val, oldVal) {
      this.isShowSearchType(val, this.selectedDate.dateType);
      if (val === "ele") {
        this.timeData = eleTimeData;
        if (
          eleTimeData.findIndex((c) => c.type == this.selectedDate.dateType) ==
          -1
        ) {
          this.$nextTick(function() {
            this.$refs.timeSearch.setSelectedFrist();
          });
        }
        this.showHomocycleRatio = true;
        this.$nextTick(function() {
          this.$refs.homocycleRatio.getData(this.analysisChartObj);
        });
      } else if (
        val === "water" ||
        val === "forwardFlow" ||
        val === "reverseFlow"
      ) {
        this.timeData = eleTimeData;
        this.$nextTick(function() {
          this.$refs.homocycleRatio.getData(this.analysisChartObj);
        });
      } else if (oldVal === "ele") {
        this.timeData = allTimeData;
        if (
          allTimeData.findIndex((c) => c.type == this.selectedDate.dateType) ==
          -1
        ) {
          this.$nextTick(function() {
            this.$refs.timeSearch.setSelectedFrist();
          });
        }
        this.showHomocycleRatio = false;
      } else {
        this.showHomocycleRatio = false;
      }
      if (!this.isStart) {
        this.getAnalysisChartData();
      }
    },
    timeControlChange(e) {
      if (this.selectedDate.dateType) {
        return
      }
      this.selectedDate = e;
      this.analysisChartObj.timeType = e.dateType;
      this.analysisChartObj.startTime = e.startTime;
      this.analysisChartObj.endTime = dayjs(e.endTime)
        .subtract(1, "second")
        .format("YYYY/MM/DD HH:mm:ss");
      this.isShowSearchType(this.selectedTab, e.dateType);
    },
    TimeControlClick(e) {
      if (
        e.dateType === "timeInterval" &&
        dayjs(e.endTime).diff(dayjs(e.startTime), "month", true) > 1
      ) {
        this.$message.warning("时段跨度不能超过一个月");
        return;
      }
      let vm = this;
      vm.selectedDate = e;
      this.analysisChartObj.timeType = e.dateType;
      this.analysisChartObj.startTime = e.startTime;
      this.analysisChartObj.endTime = dayjs(e.endTime)
        .subtract(1, "second")
        .format("YYYY/MM/DD HH:mm:ss");
      this.isShowSearchType(this.selectedTab, e.dateType);
      this.$nextTick(() => {
        vm.getAnalysisChartData();
        if (vm.$refs.homocycleRatio) {
          vm.$refs.homocycleRatio.getData(vm.analysisChartObj);
        }
      })
      // this.updateData(this.selectedTab, "");
    },
    tabTreeDefault(e) {
      let vm = this;
      this.selectedMeasure = e;
      vm.getMeasureProperty(vm.selectedMeasure.measureId);
    },
    async tabTreeClick(e) {
      let vm = this;
      this.selectedMeasure = e;
      await vm.getMeasureProperty(vm.selectedMeasure.measureId);
      // vm.updateData(this.selectedTab, '')
    },
    bindPrev() {
      this.$refs.timeSearch.prev();
    },
    bindNext() {
      this.$refs.timeSearch.next();
    },
    //获取底下图表数据
    getAnalysisChartData(e) {
      let vm = this;
      vm.analysisChartObj.timeType = vm.selectedDate.dateType;
      vm.analysisChartObj.searchType = vm.searchType;
      vm.analysisChartObj.startTime = vm.selectedDate.startTime;
      vm.analysisChartObj.endTime = dayjs(vm.selectedDate.endTime)
        .subtract(1, "second")
        .format("YYYY/MM/DD HH:mm:ss");
      vm.analysisChartObj.measureId = vm.selectedMeasure.measureId;
      vm.analysisChartObj.measureName = vm.selectedMeasure.measureName;
      vm.analysisChartObj.tabType = vm.selectedTab;
      vm.$refs.analysisChart.getData(vm.analysisChartObj);
    },
    /**
     * 是否显示采集间隔下拉框
     */
    isShowSearchType(selectedTab, dateType) {
      let vm = this;
      //只有查采集的接口才会有采集间隔
      const apiType = handleData.getTabTypeForApi(selectedTab);
      if (
        apiType === "measuring" &&
        (dateType === "day" || dateType === "timeInterval")
      ) {
        vm.showSearchType = true;
      } else {
        vm.searchType = "hour";
        vm.showSearchType = false;
      }
    },
    async getMeasureProperty(measureId) {
      let vm = this;
      vm.isStart = true;
      await api.measure.getMeasureProperty(measureId, "shield").then((res) => {
        api.measure
          .getMeasuresExpressions(JSON.stringify([measureId]))
          .then((expressionRes) => {
            //获取屏蔽的参数
            let tabArr = JSON.parse(
              JSON.stringify(
                handleData.tabData(expressionRes.data[0].expressionGroups)
              )
            );
            if (res.data.length > 0) {
              const strSheld = res.data[0].value;
              const arr = strSheld.split(",");
              for (let index = 0; index < arr.length; index++) {
                const tabIndex = tabArr.findIndex(
                  (obj) => obj.value == arr[index]
                );
                if (tabIndex > -1) {
                  tabArr.splice(tabIndex, 1);
                }
              }
            }
            vm.tabData = tabArr;
            if (tabArr.findIndex((c) => c.value == vm.selectedTab) == -1) {
              vm.selectedTab = tabArr[0].value;
            } else {
              vm.updateData(this.selectedTab, "");
            }
            vm.isStart = false;
            vm.getAnalysisChartData();
          });
      });
    },
  },
};
</script>
<style lang="scss">
.time-search-slot {
  .el-input__inner,
  .el-input__icon {
    height: 30px;
    line-height: 30px;
  }
}
</style>
<style lang="scss" scoped>
.ele-wrap {
  padding: 14px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  box-sizing: border-box;
}
.tree-content {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  margin-right: 14px;
}
.content {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
}
.grid-content {
  position: relative;
}
.details-content {
  width: 100%;
}
.table-content {
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}
.table-layout {
  width: calc(100% + 20px);
  height: 340px;
  margin: -10px -10px -10px -10px;
}
.table-layout td {
  width: 25%;
}
.table-layout tr {
  height: 100%;
}
.item-box {
  width: 100%;
  text-align: left;
  margin-top: 14px;
}
.tab-box {
  height: 32px;
}
.chart-box {
  position: relative;
  background: none;
}
.btn-circular {
  position: absolute;
  top: 150px;
  width: 50px;
  height: 50px;
  font-size: 30px;
  line-height: 50px;
  text-align: center;
  border-radius: 25px;
  color: #a7a7a7;
  z-index: 99;
}
.btn-circular:hover {
  background: #00000030;
  color: #ffffff;
  cursor: pointer;
}
.btn-circular-right {
  right: 0px;
}
.search-box {
  height: 36px;
}
.table-box {
  // padding-bottom: 20px;
}
.homocycle-ratio-box {
  width: 100%;
  height: 120px;
  padding: 10px;
  box-sizing: border-box;
}
</style>
